<template>
  <div>
    <div class="schedule" :key="key" v-for="(group, key) in value">
      <div
        class="schedule-title"
        :class="{ closed: !openedKeys.includes(key) }"
      >
        <div>
          {{ key }}
        </div>
        <v-btn
          @click="toggleGroup(key)"
          class="btn-icon btn-icon-toggle"
          :size="btnSize"
          :x-small="btnSize == 'x-small'"
          :large="btnSize == 'large'"
          color="white"
        >
          <v-icon
            color="cmf_darkgrey"
            :size="iconSize"
            :class="{ opened: openedKeys.includes(key) }"
            >$cmf_caret</v-icon
          ></v-btn
        >
      </div>
      <div class="schedule-list" v-show="openedKeys.includes(key)">
        <component
          :is="item.event_id ? 'div' : item.url ? 'a' : 'div'"
          :href="item.url ? item.url : false"
          :target="item.url ? '_blank' : false"
          class="schedule-item cmf-tablerow"
          :class="{
            dark: item.preview_urls,
            event_link: item.event_id,
            posted: item.posted
          }"
          :style="
            item.preview_urls
              ? { backgroundImage: `url(${item.preview_urls.large})` }
              : {}
          "
          v-for="item in group"
          :key="item.id"
          @click="clickSchedule(item)"
        >
          <div class="schedule-item__time">
            <span>{{
              item.start_at | moment("timezone", "America/New_York", "h:mm")
            }}</span
            >-<span>{{
              item.end_at | moment("timezone", "America/New_York", "h:mma")
            }}</span>
            ET
          </div>
          <div class="schedule-item__details">
            <div class="schedule-item__title-tag">
              <span class="schedule-item__title" v-html="item.title"></span>
              <span class="schedule-item__tag"> {{ item.tag_label }}</span>
            </div>
            <div
              class="schedule-item__description"
              v-html="item.description"
            ></div>
          </div>
        </component>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Schedule",
  props: {
    value: Object
  },
  data() {
    return {
      openedKeys: []
    };
  },
  mounted() {
    this.setPosted();
  },
  watch: {
    value() {
      this.setPosted();
    }
  },
  methods: {
    setPosted() {
      for (const [key, group] of Object.entries(this.value)) {
        console.info(key);
        group.forEach(item => {
          if (item.event && item.event.start_at) {
            let until = Date.parse(item.event.start_at) - Date.now();
            if (until < 0) {
              item.posted = true;
            } else {
              item.posted = false;
              setTimeout(item => {
                console.info("setTimeout item", item);
                item.posted = true;
              }, until);
            }
          } else {
            item.posted = true;
          }
        });
      }
    },
    clickSchedule(item) {
      if (item.event && item.posted) {
        this.$root.$emit("setActiveEvent", { ...item.event });
        window.scrollTo(0, 0);
      }
      if (item.event_id) {
        this.$gtag.event("Schedule", {
          event_category: "click",
          event_label: "scheduleId",
          value: item.event_id
        });
      }
    },
    toggleGroup(key) {
      if (this.openedKeys.includes(key))
        this.openedKeys = this.openedKeys.filter(s => s != key);
      else this.openedKeys.push(key);
    },
    pageSlug(item) {
      return item.page_slug == "home" ? "" : item.page_slug;
    }
  },
  computed: {
    btnSize() {
      const btnSize = {
        sm: "x-small",
        xs: "x-small"
      };

      return btnSize[this.$size] || "large";
    },
    iconSize() {
      const iconSize = {
        sm: 21,
        xs: 21
      };

      return iconSize[this.$size] || 33;
    }
  }
};
</script>

<style scoped lang="scss">
.schedule {
  color: $primary;

  &-title {
    font-weight: 300;
    font-size: 36px;
    line-height: 1.1em;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    padding: 30px 120px;
    &.closed {
      border-bottom: 2px solid $primary;
    }
    @media screen and (max-width: 1264px) {
      padding: 30px 30px 30px 56px;
    }
    @media screen and (max-width: 960px) {
      font-size: 28px;
      padding: 30px 20px;
    }
  }

  &-list {
    background: white;
  }

  &-item {
    overflow: hidden;
    align-items: stretch;
    display: flex;
    justify-content: flex-start;
    text-decoration: none;

    font-size: 20px;
    @media screen and (max-width: 960px) {
      font-size: 18px;
    }
    line-height: 1.3;

    &__title-tag {
      margin-bottom: 10px;
    }

    &__title {
      font-weight: 700;
      @media screen and (max-width: 960px) {
        font-size: 19px;
      }
    }
    &__tag {
      margin-right: 0;
      margin-left: 10px;
      @media screen and (max-width: 960px) {
        margin-left: 0;
      }
    }
  }
}

a.schedule-item.posted:hover,
.event_link.schedule-item.posted:hover {
  text-decoration: underline;
  cursor: pointer;
}

@media screen and (max-width: 960px) {
  .schedule-item {
    &__title,
    &__time {
      display: block;
      margin-right: 0;
      margin-bottom: 10px;
    }
  }
}
</style>
